<template>
    <div>
        <div class='searchBox'>
            <el-form :inline="true" :model="searchForm" ref="searchForm">
                <el-form-item label="标识代码" prop='dm'>
                    <el-input v-model="searchForm.dm"></el-input>
                </el-form-item>
                <el-form-item label="标识名称" prop='mc'>
                    <el-input v-model="searchForm.mc"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="search">查询</el-button>
                    <el-button type="primary" @click="resetForm('searchForm')">重置</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class='btnsBox'>
            <el-button type="primary" @click="add">新增</el-button>
            <el-button type="primary" @click="del()" :disabled="multipleSelection.length==0">删除</el-button>
        </div>
        <el-table
            ref="table"
            border
            :data="tableData"
            style="width: 100%"
            row-key="id"
            @selection-change="handleSelectionChange"

        >
            <el-table-column type="selection" width="50"></el-table-column>
            <el-table-column type="index" label="序号" width="70">
                <template slot-scope="scope">{{(currentPage - 1) * pageSize + scope.$index + 1}}</template>
            </el-table-column>
            <el-table-column prop="dm" label="标识代码"  width="120" show-overflow-tooltip></el-table-column>
            <el-table-column prop="mc" label="标识名称"  min-width="180" show-overflow-tooltip></el-table-column>
            <el-table-column prop="xsz" label="显示值"  min-width="160" show-overflow-tooltip></el-table-column>
            <el-table-column prop="lxm" label="类型码" width="80"></el-table-column>
            <el-table-column prop="sfky" label="是否可用" width="80" :formatter="ztFormatter"></el-table-column>
            <el-table-column prop="pxh" label="排序号" width="80"></el-table-column>
            <el-table-column  label="操作" width="140" fixed='right'>
                <template slot-scope="scope">
                    <el-button type="text"  @click='edit(scope.row)'>编辑</el-button>
                    <el-button type="text"  @click='look(scope.row)'>查看</el-button>
                    <el-button type="text"  @click='del(scope.row)'>删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="clear">
            <span class="lf pageNum">共{{total}}条。</span>
            <myPage
            class="rt"
            :total="total"
            :page-size="pageSize"
            :currentPage="currentPage"
            @changePage="changePage"
            ></myPage>
        </div>
        <!-- 新增编辑 -->
        <el-dialog :title='lx+"码表"' :visible.sync="dialogVisible" width='800px' lock-scroll :close-on-click-modal="false">
            <el-form :model="form" ref="form" label-width="100px" :rules="formRules" :disabled="isLook">
                <el-row>
                    <el-col :span='12'>
                        <el-form-item label="标识代码" prop='dm'>
                            <el-input v-model="form.dm"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span='12'>
                        <el-form-item label="标识名称" prop='mc'>
                            <el-input v-model="form.mc"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span='12'>
                        <el-form-item label="显示值" prop='xsz'>
                            <el-input v-model="form.xsz"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span='12'>
                        <el-form-item label="类型码"  prop='lxm'>
                            <el-input v-model="form.lxm"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span='12'>
                        <el-form-item label="是否可用">
                            <el-radio-group v-model="form.sfky">
                                <el-radio :label="1">是</el-radio>
                                <el-radio :label="0">否</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                    <el-col :span='12'>
                        <el-form-item label="排序号" prop='pxh'>
                            <el-input v-model="form.pxh"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div class='btnBox'>
                <el-button type="primary" @click='saveForm("form")'>确定</el-button>
                <el-button type="primary" @click='resetForm("form")' v-if='!isLook'>重置</el-button>
                <el-button type="primary" @click='cancelForm("form")' v-if='!isLook'>取消</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import myPage from '../../components/page'
export default {
    name:'',
    components:{
        myPage
    },
    props:[
        'adminLx'
    ],
    data(){
        return{
            searchForm:{
                mc:'',
                dm:''
            },
            tableData:[],
            total:0,
            pageSize:10,
            currentPage:1,
            multipleSelection:[],
            dialogVisible:false,
            lx:'新增',
            isLook:false,
            form:{

            },
            formRules:{
                dm:[{required:true,trigger:'blur',message:'必填项'}],
                mc:[{required:true,trigger:'blur',message:'必填项'}],
                pxh:[{required:true,trigger:'blur',message:'必填项'}],
            }
        }
    },
    methods:{
        getData(){
            let para=this.searchForm;
            para.currentPage=this.currentPage;
            para.pageSize=this.pageSize;
            para.lx=this.adminLx
            this.$api.getMbgl(para).then(res=>{
                if(res.data.meta.success){
                    this.tableData=res.data.data.list;
                    this.total=res.data.data.total;
                }else{
                    this.$message({
                        type:'error',
                        message:res.data.meta.message
                    })
                }
            }).catch(()=>{})
        },
        search(){
            this.currentPage=1;
            this.getData();
        },
        //新增
        add(){
            this.dialogVisible=true;
            this.lx='新增';
            this.isLook=false;
            this.form={
                dm:'',
                mc:'',
                xsz:'',
                pxh:'',
                lxm:'',
                sfky:1
            }
        },
        //编辑
        edit(row){
            this.dialogVisible=true;
            this.lx='编辑';
            this.isLook=false;
            this.form=Object.assign({},row)
        },
        //查看
        look(row){
            this.dialogVisible=true;
            this.lx='查看';
            this.isLook=true;
            this.form=Object.assign({},row)
        },
        saveForm(formName){
            if(this.isLook){
                this.dialogVisible=false;
            }else{
                this.$refs[formName].validate((valid)=>{
                    if(valid){
                        let para=this.form;
                        para.lx=this.adminLx
                        this.$api.saveMbgl(para).then(res=>{
                            if(res.data.meta.success){
                                this.$message({
                                    type:'success',
                                    message:'保存成功！'
                                })
                                this.dialogVisible=false;
                                this.getData();
                            }else{
                                this.$message({
                                    type:'error',
                                    message:res.data.meta.message
                                })
                            }
                        }).catch(()=>{})
                    }else{
                        return false;
                    }
                })
            }
        },
        //重置
        resetForm(formName){
            this.$refs[formName].resetFields();
        },
        cancelForm(formName){
            this.$refs[formName].resetFields();
            this.dialogVisible=false
        },
        //删除
        del(row){
            let text=''
            let para={
                lx:this.adminLx
            }
            if(row){
                text='确定要删除当前的流程吗？'
                para.id=row.id
            }else{
                text='确定要删除选中的流程吗？';
                let ids=''
                this.multipleSelection.forEach(item=>{
                    ids+=item.id+','
                })
                para.id=ids.slice(0,ids.length-1)
            }
            this.$confirm(text, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$api.delMbgl(para).then(res=>{
                    if(res.data.meta.success){
                        this.$message({
                            type:'success',
                            message:'删除成功！'
                        })
                        this.getData();
                    }else{
                        this.$message({
                            type:'error',
                            message:res.data.meta.message
                        })
                    }
                }).catch(()=>{})
            }).catch(() => {
                      
            });
        },
        changePage(val){
            this.currentPage=val;
            this.getData();
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        ztFormatter(row,col,column,index){
            return row.sfky==1?'是':'否'
        },
    },
    mounted(){
        this.getData();
    }
}
</script>  
<style lang="less" scoped>

</style>